import { authenticationStore } from "../api/authentication/authentication.module";
import { AuthenticationService } from "../shared/helpers";

const authService = new AuthenticationService();

export async function AppGuard(to: any, from: any, next: any) {
  try {
    const user = await authService.checkLogin();
    if (!user.verified) {
      authenticationStore.LOGOUT();
      throw new Error("Account not verified");
    }
    next();
  } catch (error) {
    // console.log("AppGuard", error);
    next("/login");
  }
}

export async function LoginGuard(to: any, from: any, next: any) {
  try {
    await authService.checkLogin();
    next("/app");
  } catch (error) {
    // console.log("LoginGuard", error);
    next();
  }
}
